import { TechRefStore } from '@squareup/dex-tech-shell';
import { useStore } from 'react-redux';

export const useTechRefStore: () => TechRefStore = useStore;
